// Packages and components
import React from 'react';
import { Box } from 'grommet';
import SHDButton from '@ui/Button/SHDButton';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDText from '@ui/Text/SHDText';

// Helpers and utilities
import { useAcceptTos } from '@hooks/useAdmin';

// Types and enums
import type { AcceptTosProps } from '../../admin.types';

const AcceptTos: React.FC<AcceptTosProps> = ({ userId }) => {
  const { acceptTos, error, success } = useAcceptTos();

  const handleAcceptButtonClick = async () => {
    await acceptTos(userId);
  };
  return (
    <Box direction="column" gap="xsmall">
      <Box direction="column" gap="xxsmall">
        <SHDHeading level={4}>Terms of Service</SHDHeading>
        <SHDText>
          Click the button below to accept the Terms of Service for user{' '}
          {userId}.
        </SHDText>
      </Box>
      <Box>
        {error && (
          <Box
            background="dk-red-alpha-10"
            border={{ side: 'all', color: 'dk-red-alpha-20' }}
            pad="medium"
            round="xsmall"
          >
            <SHDText color="dk-red-800">{error.message}</SHDText>
          </Box>
        )}

        {success && (
          <Box
            background="dk-green-alpha-10"
            border={{ side: 'all', color: 'shd-green-dark-alpha-30' }}
            pad="medium"
            round="xsmall"
          >
            <SHDText color="dk-green-800">{success.message}</SHDText>
          </Box>
        )}
      </Box>
      <SHDButton primary label="Accept" onClick={handleAcceptButtonClick} />
    </Box>
  );
};

export default AcceptTos;
